import { APP_VERSION } from '../generated/appVersion';

export const parseVersionParts = (value) => {
  const raw = String(value || '').trim();
  if (!raw) return [];
  return (raw.match(/\d+/g) || []).map((part) => Number(part));
};

export const compareVersions = (left, right) => {
  const leftParts = parseVersionParts(left);
  const rightParts = parseVersionParts(right);
  const maxLength = Math.max(leftParts.length, rightParts.length);

  for (let index = 0; index < maxLength; index += 1) {
    const leftItem = leftParts[index] || 0;
    const rightItem = rightParts[index] || 0;
    if (leftItem < rightItem) return -1;
    if (leftItem > rightItem) return 1;
  }

  return 0;
};

export const isUpdateNews = (item) => String(item?.category || '').toLowerCase() === 'update';

export const isUpdateRelevant = (item, currentVersion = APP_VERSION) => {
  if (!isUpdateNews(item)) return true;
  if (!currentVersion) return true;

  const appVersion = String(item?.app_version || '').trim();
  const minSupportedVersion = String(item?.min_supported_version || '').trim();

  if (minSupportedVersion && compareVersions(currentVersion, minSupportedVersion) < 0) return true;
  if (appVersion && compareVersions(currentVersion, appVersion) < 0) return true;
  return false;
};

export const isUpdateRequiredNow = (item, currentVersion = APP_VERSION) => {
  if (!isUpdateNews(item) || !currentVersion) return false;
  if (item?.update_is_required_now === true) return true;

  const appVersion = String(item?.app_version || '').trim();
  const minSupportedVersion = String(item?.min_supported_version || '').trim();

  if (minSupportedVersion && compareVersions(currentVersion, minSupportedVersion) < 0) return true;
  return Boolean(item?.is_required_update && appVersion && compareVersions(currentVersion, appVersion) < 0);
};

const wait = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

export const reloadForAppUpdate = async ({ minDelayMs = 2500 } = {}) => {
  const startedAt = Date.now();
  const reload = async () => {
    const remainingDelay = Math.max(0, minDelayMs - (Date.now() - startedAt));
    if (remainingDelay > 0) {
      await wait(remainingDelay);
    }
    window.location.reload();
  };

  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    await reload();
    return;
  }

  try {
    const registration = await navigator.serviceWorker.getRegistration('/');
    await registration?.update?.();
    if (registration?.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
  } catch (error) {
    console.warn('Не удалось обновить service worker перед перезагрузкой:', error);
  }

  await reload();
};
